import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, useHistory } from 'react-router-dom';

import App from './App';

// Wrapper component to get history from BrowserRouter
const AppWrapper: React.FC = () => {
  const history = useHistory();
  return <App history={history} />;
};

render(
  <React.StrictMode>
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);
